import {ChangeDetectorRef, Component} from '@angular/core';
import {AuthService} from '../../services/auth.service';
import {UserService} from '../../services/user.service';

import {Subscription as RxSubscription} from 'rxjs';
import {CommonService} from '../../services/common.service';
@Component({
    selector: 'pc-header',
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
    standalone: false
})
export class HeaderComponent {
  public openMenu = false;
  public isLoggedIn: string | boolean | null = false;

  public mobileSearchOpen = false;
  private Subscriptions: RxSubscription[] = [];
  public gazetteUrl;

  public user;
  constructor(
    public authService: AuthService,
    public userService: UserService,
    public commonService: CommonService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.Subscriptions.push(
      this.authService.isAuthenticated.subscribe(authenticated => {
        this.isLoggedIn = authenticated;
        this.cdr.detectChanges();
      })
    );
    this.Subscriptions.push(
      this.userService.User.subscribe(data => {
        this.user = data?.User;
        this.gazetteUrl = data?.User?.canUserSeeGazette
          ? data.User.gazetteUrl
          : null;
      })
    );
  }

  public navigate(path) {
    this.commonService.navigate(path);
  }
}
